import { defineMeta } from '@/registry/types';

export const meterMeta = defineMeta({
  name: 'Meter',
  level: 'molecule',
  category: 'data-display',
  classification: 'custom',
  description:
    'Radial progress ring for a single bounded score or grade. Replaces three divergent gauge implementations.',
  baseLibrary: 'custom',
  importPath: '@/molecules/Meter',
  requiredProps: ['value', 'label'],
  optionalProps: ['displayValue', 'tone', 'size', 'strokeWidth'],
  supportedStates: ['default', 'empty', 'full'],
  designTokens: ['chart', 'severity'],
  accessibility: [
    'Exposes role="meter" with aria-valuenow/min/max and a required aria-label.',
    'The numeric value is always rendered as text inside the ring, never conveyed by arc length alone.',
  ],
  usageExamples: [
    '<Meter value={72} label="Detection coverage" />',
    '<Meter value={31} tone="critical" label="Risk score" displayValue="31%" />',
  ],
  antiPatterns: ['Do not use for unbounded quantities — a meter implies a 0-100 range.'],
  llmSafe: true,
  whenToUse: ['A single bounded score, grade or percentage'],
  whenNotToUse: ['Multiple values or a trend over time'],
});

export default meterMeta;
